import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ReceivingShipmentService } from '../../service/api/receiving-shipment-service';

const POShipmentsModal = ({ show, poId, onClose }) => {
  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && poId) {
      setLoading(true);
      setShipments([]);
      ReceivingShipmentService.getShipmentsByPOQuery({ POId: poId })
        .then(response => {
          if (response.status === 200 && Array.isArray(response.response)) {
            setShipments(response.response);
          } else {
            setShipments([]);
          }
        })
        .catch(() => setShipments([]))
        .finally(() => setLoading(false));
    }
  }, [show, poId]);

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Shipments for PO</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center p-4">Loading shipments...</div>
        ) : shipments.length === 0 ? (
          <div className="text-center p-4">No shipments found.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Shipment Number</th>
                </tr>
              </thead>
              <tbody>
                {shipments.map(s => (
                  <tr key={s.receivingShipmentID}>
                    <td>{s.shipmentNumber}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default POShipmentsModal; 